
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Category",
      function () {
        return require("private-next-pages/Category.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Category"])
      });
    }
  